import { SiteDetailsPage } from './SiteDetails';
import { createHandle } from './handle';
import { createLoader } from './loader';

export default {
  Component: SiteDetailsPage,
  createHandle,
  createLoader
};
